import dynamic from "next/dynamic";
import {useTranslation} from "next-i18next";

// @ts-ignore
const DynamicWhatsAppWidget = dynamic(() => import("react-whatsapp-chat-widget"), {
    ssr: false,
})

export const WhatsApp = () => {
    const {t} = useTranslation()
    return <>

        <DynamicWhatsAppWidget
            // @ts-ignore
            phoneNo='+33757903136'
            position='right'
            widgetWidth='300px'
            widgetWidthMobile='260px'
            autoOpen={false}
            autoOpenTimer={5000}
            messageBox={true}
            messageBoxTxt=''
            iconSize='48'
            iconColor='white'
            iconBgColor='#40c151'
            headerIcon='https://storage.googleapis.com/assets.prod.seacrush.com/public/prod/images/about/about_page_isabelle_96__.webp'
            headerIconColor='black'
            headerTxtColor='white'
            headerBgColor='#383838'
            headerTitle='Isabelle'
            headerCaption='Online'
            bodyBgColor='#bbb'
            chatPersonName='Isabelle'
            chatMessage={<>{t("hi-there")} 👋 <br/><br/> {t("how-can-i-help-you")}</>}
            footerBgColor='#999'
            placeholder={t("type-a-message")}
            btnBgColor='#40c151'
            btnTxt='Send WhatsApp'
            btnTxtColor='white'
        />
    </>
}

